<div class="SCWEB-confirm-footer">
  <img class="logo" src="assets/img/shortcut-logo-white.png" (click)="goToWebsite()" />
  <p class="copyright">All Rights Reserved. Copyright 2020.</p>
</div>